import { inboxConstants } from "_constants";

const INITIAL_STATE = {
  messages: {},
  loading: true,
  error: "",

  parentPost: { post: null, authors: {} },
  loadingParentPost: false,
  parentPostError: "",

  messageLock: null,
  loadingMessageLock: false,
  messageLockError: "",

  generatedReply: null,
  loadingGeneratedReply: false,
  generatedReplyError: "",
};

export function inboxReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case inboxConstants.GET_ORG_INBOX_MESSAGES_REQUEST:
      return { ...state, loading: true, error: "" };
    case inboxConstants.GET_ORG_INBOX_MESSAGES_SUCCESS:
      return { ...state, messages: action.payload, loading: false };
    case inboxConstants.GET_ORG_INBOX_MESSAGES_FAILURE:
      return { ...state, error: action.error, loading: false };

    case inboxConstants.GET_PARENT_POST_REQUEST:
      return {
        ...state,
        loadingParentPost: true,
        parentPostError: "",
      };
    case inboxConstants.GET_PARENT_POST_SUCCESS:
      return {
        ...state,
        parentPost: action.payload,
        loadingParentPost: false,
      };
    case inboxConstants.GET_PARENT_POST_FAILURE:
      return {
        ...state,
        parentPostError: action.payload,
        loadingParentPost: false,
      };

    case inboxConstants.LOCK_MESSAGE_REQUEST:
      return {
        ...state,
        loadingMessageLock: true,
        messageLock: action.keepExisting ? state.messageLock : null,
        messageLockError: "",
      };
    case inboxConstants.LOCK_MESSAGE_SUCCESS:
      return {
        ...state,
        messageLock: action.payload,
        loadingMessageLock: false,
      };
    case inboxConstants.LOCK_MESSAGE_FAILURE:
      return {
        ...state,
        messageLockError: action.payload,
        loadingMessageLock: false,
      };

    case inboxConstants.REGENERATE_REPLY_REQUEST:
      return {
        ...state,
        loadingGeneratedReply: true,
        generatedReplyError: "",
      };
    case inboxConstants.REGENERATE_REPLY_SUCCESS:
      return {
        ...state,
        generatedReply: action.payload,
        loadingGeneratedReply: false,
      };
    case inboxConstants.REGENERATE_REPLY_FAILURE:
      return {
        ...state,
        generatedReplyError: action.payload,
        loadingGeneratedReply: false,
      };

    default:
      return state;
  }
}
